import axios from "axios";
import authHeader from "@/Api/AuthHeader";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getAllStudents() {
      await axios
        .get(URL_API + "estudantes", { headers: authHeader() })
        .then((response) => {
          console.log(response);
        });
    },

    async viewEstudante(id) {
      const resp = await axios.get(URL_API + `estudantes/${id}`, {
        headers: authHeader(),
      });

      return resp;
    },

    async createInscritpion(datas) {
      try {
        const resp = await axios.post(URL_API + "estudantes", datas, {
          headers: authHeader(),
        });
        return resp;
      } catch (err) {
        return err;
      }
    },

    async updateEstudante(estudante, id) {
      return axios.patch(URL_API + `estudantes/${id}`, estudante, {
        headers: authHeader(),
      });
    },

    updateEstudanteClassmate(classmateData, id) {
      return axios.post(
        URL_API + `updateClassmateStudant/${id}`,
        classmateData,
        { headers: authHeader() }
      );
    },

    async deleteStudent(id) {
      await axios.delete(URL_API + `estudantes/${id}`);
    },

    async getProvinces() {
      try {
        const resp = await axios.get(URL_API + "provinces");

        return resp;
      } catch (error) {
        return error;
      }
    },

    async ChangeProvince(evt) {
      this.loadDistricts = true;
      console.log(evt.target.value);

      await axios
        .get(URL_API + "district/" + evt.target.value)
        .then((response) => {
          // console.log(response);
          this.districtData = response.data;
          this.loadDistricts = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getAllCourses() {
      try {
        const resp = await axios.get(URL_API + "getAllCourses");

        return resp;
      } catch (error) {
        return error;
      }
    },
    async getOnlyCourses() {
      try {
        const resp = await axios.get(URL_API + "getOnlyCourses");

        return resp;
      } catch (error) {
        return error;
      }
    },
    async getSemesters() {
      try {
        const resp = await axios.get(URL_API + "semesters", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getLevels() {
      try {
        const resp = await axios.get(URL_API + "levels", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },
    async getLevelsCandi() {
      try {
        const resp = await axios.get(URL_API + "getlevels");

        return resp;
      } catch (error) {
        return error;
      }
    },

    async academicYears() {
      try {
        const resp = await axios.get(URL_API + "academic-years", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getClassmate() {
      try {
        const resp = await axios.get(URL_API + "getTurmas", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getAllStudent(data) {
      try {
        const resp = await axios.get(
          URL_API + `estudantes?page=${data.page}&search=${data.search}`,
          {
            headers: authHeader(),
          }
        );

        return resp.data;
      } catch (error) {
        return error;
      }
    },

    async fetchStudent(data) {
      try {
        const resp = await axios.get(
          URL_API + `fetchStudent?search=${data.search}`,
          {
            headers: authHeader(),
          }
        );

        return resp.data;
      } catch (error) {
        return error;
      }
    },

    // Get student withou paginate
    getAllStudentWithoutPaginate() {
      return axios.get(URL_API + `getStudantesWithoutPaginate`, {
        headers: authHeader(),
      });
    },

    deleteStudent(student_id) {
      return axios.delete(URL_API + `estudantes/${student_id}`, {
        headers: authHeader(),
      });
    },

    async getNotifications() {
      return axios.get(URL_API + "communications", { headers: authHeader() });
    },

    async updateStatusNotification(notidication_id, type) {
      return axios.get(
        URL_API +
          `commnucationStudent?notification_id=${notidication_id}&type=${type}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getEnrolledSubjcts(student_id) {
      return axios.get(
        URL_API + `getEnrolledSubjcts?student_id=${student_id}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getNormalSubjectSemester(student_id) {
      return axios.get(
        URL_API + `getNormalSubjectSemester?student_id=${student_id}`,
        {
          headers: authHeader(),
        }
      );
    },

    async addEnrollSubject(
      subjectSelected,
      student_id = null,
      course_id = null
    ) {
      return axios.post(
        URL_API + `assignSubject `,
        {
          subjectSelected: subjectSelected,
          student_id: student_id,
          course_id: course_id,
        },

        {
          headers: authHeader(),
        }
      );
    },

    async getRecoverSubjectSemester(student_id) {
      return axios.get(
        URL_API + `getRecoverSubjectSemester?student_id=${student_id} `,
        {
          headers: authHeader(),
        }
      );
    },

    async getStudentInfo(data) {
      return axios.get(
        URL_API +
          `getStudentInfo?student_card=${data.student_card}&course_id=${data.course_id}`,
        {
          headers: authHeader(),
        }
      );
    },

    async enrollStudentSubjects(studentsToSubscribe, classmate_id, course_id) {
      return axios.post(
        URL_API +
          `enrollStudentSubjects?classmate_id=${classmate_id}&course_id=${course_id}`,
        { data: studentsToSubscribe },
        {
          headers: authHeader(),
        }
      );
    },
    async getStudentByCourseId(data) {
      return axios.get(
        URL_API +
          `getStudentByCourseId?course_id=${data.course_id}&page=${data.page}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getStudentEnrolled(data) {
      return axios.get(URL_API + `studentsEnrolled?page=${data.page}`, {
        headers: authHeader(),
      });
    },
    async getStudentAlocated(data) {
      return axios.get(
        URL_API + `AllAlocatedstudentsEnrolled?page=${data.page}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getStudentAlocatedBySearch(data) {
      return axios.get(
        URL_API +
          `getStudentAlocatedBySearch?page=${data.page}&search=${data.search}`,
        {
          headers: authHeader(),
        }
      );
    },

    async getStudentBySearch(data) {
      return axios.get(
        URL_API +
          `getStudentBySearch?page=${data.page}&course_id=${data.course_id}&search=${data.search}`,
        {
          headers: authHeader(),
        }
      );
    },

    async getAllDataStudentHistoric(student_id) {
      return axios.get(
        URL_API + `getAllDataStudentHistoric?student_id=${student_id}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getAlocatedStudent(filters, page) {
      return axios.get(
        URL_API +
          `alocatedStudent?page=${page}&year=${filters.year}&semester_id=${filters.semester_id}&course_id=${filters.course_id}&classmate_id=${filters.classmate_id}`,
        {
          headers: authHeader(),
        }
      );
    },
  },
};
